import { useMemo } from "react"

import { DateTime } from "@bounce/date"
import { useTranslation } from "@bounce/i18n"

import type { Review } from "@/utils/reviews"

export const useReviewSlider = (reviews: Review[]) => {
  const { t } = useTranslation("marketing-ls-store")

  return useMemo(() => {
    const today = DateTime.now()
    const isMonday = today.weekday === 1

    // If Monday, start from previous week, otherwise current week
    const startOfWeek = isMonday ? today.minus({ weeks: 1 }).startOf("week") : today.startOf("week")
    const endOfWeek = startOfWeek.plus({ days: 6 }).endOf("day")
    const currentWeekReviews = reviews.filter(review => {
      const reviewDate = DateTime.fromISO(review.completedAt)

      return reviewDate >= startOfWeek && reviewDate <= endOfWeek
    })

    if (currentWeekReviews.length < 10) {
      return {
        subtitle: undefined,
      }
    }

    return {
      subtitle: t(
        "screen.storeScreen.reviewsSlider.storePageSubtitle",
        "More than {{reviewLength}} people have stored their bags at this location in the last week",
        {
          reviewLength: Math.floor(currentWeekReviews.length / 5) * 5,
        },
      ),
    }
  }, [reviews, t])
}
